import { render, staticRenderFns } from "./DetailFaktur.vue?vue&type=template&id=11111704&scoped=true&"
import script from "./DetailFaktur.vue?vue&type=script&lang=js&"
export * from "./DetailFaktur.vue?vue&type=script&lang=js&"
import style0 from "./DetailFaktur.vue?vue&type=style&index=0&id=11111704&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11111704",
  null
  
)

export default component.exports